module.exports = __webpack_public_path__ + "static/media/14_pol_0_84.54.72735efb.png";